import { calculateEnergyKcal } from "@/lib/calculateEnergyKcal";
import { clamp, roundToNearest } from "@/lib/utils";
import type { IngredientDraft } from "./preparation";
type SweetenerComposition = Pick<
  IngredientDraft,
  | "sugarsPct"
  | "waterPct"
  | "fatPct"
  | "proteinPct"
  | "carbPct"
  | "fiberPct"
  | "alcoholPct"
  | "energyKcal"
  | "pac"
  | "pod"
>;

export function calculateSweetenerComposition(
  waterPct: number,
  pac: number,
  pod: number,
): SweetenerComposition {
  const sugarsPct = clamp(1 - waterPct, 0, 1);

  return {
    sugarsPct,
    waterPct,
    fatPct: 0,
    proteinPct: 0,
    carbPct: sugarsPct,
    fiberPct: 0,
    alcoholPct: 0,
    energyKcal: roundToNearest(
      calculateEnergyKcal({
        sugarsPct: sugarsPct,
      }),
      0.01,
    ),
    pac,
    pod,
  };
}
